// modules/SettingsHelper.js
// 设置辅助模块 - 用于获取和应用游戏设置
import DebugHelper from './DebugHelper.js';
import StorageHelper from './StorageHelper.js';
import GameStateStore from './GameStateStore.js';

// 默认游戏设置常量
export const DEFAULT_SETTINGS = {
    soundVolume: 1.0,
    musicVolume: 1.0,
    battleMessages: true,
    autoBattle: false
};

export default class SettingsHelper {
    /**
     * 获取当前游戏设置
     * @returns {Object} 设置对象
     */
    static getSettings() {
        const stored = GameStateStore.getSettings();
        if (stored) {
            return stored;
        }

        const savedSettings = StorageHelper.getItem('gameSettings');
        if (savedSettings) {
            return savedSettings;
        }

        return { ...DEFAULT_SETTINGS };
    }

    /**
     * 获取音效音量（0-1）
     * @returns {number} 音效音量
     */
    static getSoundVolume() {
        const settings = this.getSettings();
        return settings.soundVolume || 1.0;
    }

    /**
     * 获取BGM音量（0-1）
     * @returns {number} BGM音量
     */
    static getMusicVolume() {
        const settings = this.getSettings();
        return settings.musicVolume || 1.0;
    }

    /**
     * 获取BGM播放音量（应用基础音量0.1）
     * @returns {number} 实际播放音量
     */
    static getBGMPlayVolume() {
        return this.getMusicVolume() * 0.1;
    }

    /**
     * 获取音效播放音量（应用基础音量）
     * @param {number} baseVolume - 基础音量（默认0.3）
     * @returns {number} 实际播放音量
     */
    static getSoundPlayVolume(baseVolume = 0.3) {
        return this.getSoundVolume() * baseVolume;
    }

    /**
     * 是否显示战斗消息
     * @returns {boolean}
     */
    static shouldShowBattleMessages() {
        const settings = this.getSettings();
        return settings.battleMessages !== false;
    }

    /**
     * 是否启用自动战斗
     * @returns {boolean}
     */
    static isAutoBattleEnabled() {
        const settings = this.getSettings();
        return settings.autoBattle === true;
    }

    /**
     * 更新设置
     * @param {Object} newSettings - 新设置对象
     */
    static updateSettings(newSettings) {
        const merged = {
            ...this.getSettings(),
            ...newSettings
        };
        GameStateStore.updateSettings(merged);
        StorageHelper.setItem('gameSettings', merged);
    }
}
